import {
  IApplicationSection,
  IPermissionAction,
  IPermissionChildGroup,
  IPermissionGroup,
} from './permissions';

const matches = (value: string, query: string): boolean => value.toLowerCase().includes(query);

const matchingActions = (actions: IPermissionAction[], query: string): IPermissionAction[] =>
  actions.filter(
    (action) => !action.disabled && (matches(action.label, query) || matches(action.name, query)),
  );

const filterGroup = (group: IPermissionGroup, query: string): IPermissionGroup | null => {
  if (matches(group.label, query)) return group;

  const children = group.children
    .map((child): IPermissionChildGroup | null => {
      if (matches(child.label, query)) return child;
      const actions = matchingActions(child.actions, query);
      return actions.length > 0 ? { ...child, actions } : null;
    })
    .filter((child): child is IPermissionChildGroup => child !== null);

  const ownMatches = matchingActions(group.actions, query);

  if (ownMatches.length === 0 && children.length === 0) return null;

  return { ...group, actions: ownMatches, children };
};

export const filterSections = (
  sections: IApplicationSection[],
  term: string,
): IApplicationSection[] => {
  const query = term.trim().toLowerCase();
  if (!query) return sections;

  return sections
    .map((section) => ({
      ...section,
      groups: section.groups
        .map((group) => filterGroup(group, query))
        .filter((group): group is IPermissionGroup => group !== null),
    }))
    .filter((section) => section.groups.length > 0);
};
